"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Body_1 = require("./Body");
const Footer_1 = require("./Footer");
const Header_1 = require("./Header");
const constants_1 = require("../../constants");
const Dialog_1 = require("../Dialog");
const Flex_1 = require("../Flex");
const Paper_1 = require("../Paper");
const Actions_1 = require("./Actions");
const stackCountSharedStyles = {
    content: '""',
    position: 'absolute',
    height: '100%',
    width: '100%',
    backgroundColor: constants_1.Color.WHITE,
    border: `1px solid ${constants_1.theme.color.border}`,
    borderRadius: constants_1.theme.border.radius.normal,
    boxShadow: constants_1.theme.boxShadow.elevated,
};
const templateStyles = {
    display: 'grid',
    gridTemplateAreas: `
    "Header Actions"
    "Body Body"
    "Footer Footer"
  `,
    gridTemplateColumns: '1fr auto',
};
const CardWrapper = (0, styled_1.default)(Paper_1.Paper)(({ stackCount, width }) => ({
    ...templateStyles,
    width,
    maxHeight: '95vh',
    position: 'relative',
    boxShadow: constants_1.theme.boxShadow.elevated,
    ...(stackCount && stackCount > 1
        ? {
            '::before': {
                ...stackCountSharedStyles,
                top: 6,
                right: -6,
                zIndex: -1,
            },
        }
        : {}),
    ...(stackCount && stackCount > 2
        ? {
            '::after': {
                ...stackCountSharedStyles,
                top: 12,
                right: -12,
                zIndex: -2,
            },
        }
        : {}),
}));
const SidebarWrapper = (0, styled_1.default)(Flex_1.Flex)(({ width }) => ({
    ...templateStyles,
    background: 'white',
    minWidth: width,
    height: '100%',
    flex: 1,
    boxShadow: constants_1.theme.boxShadow.elevated,
    zIndex: constants_1.theme.zIndex.contentpagesidebar,
    flexDirection: 'column',
}));
const ActionCard = ({ className, children, stackCount, as, width = 360, icons, onClose, }) => {
    const Root = as === 'sidebar' ? SidebarWrapper : CardWrapper;
    return ((0, jsx_runtime_1.jsxs)(Root, { as: as === 'dialog' ? Dialog_1.Dialog.Panel : undefined, className: className, stackCount: stackCount, width: width, children: [children, (0, jsx_runtime_1.jsx)(Actions_1.Actions, { as: as, icons: icons, onClose: onClose })] }));
};
exports.ActionCard = ActionCard;
ActionCard.Header = Header_1.Header;
ActionCard.Body = Body_1.Body;
ActionCard.Footer = Footer_1.Footer;
